import React, { useReducer } from 'react'
import { getAllResourcesInPlaceByAreas, getAllResourcesInPlaceByBuilding, getAllResourcesInPlaceByOpennings } from '../../services/DashboardServices';
import { t } from 'i18next';
import { logout } from '../../services/login';
import WidgetResourcesInPlaceReducer from './WidgetResourcesInPlaceReducer';
import WidgetResourcesInPlaceContext from './WidgetResourcesInPlaceContext';
import { getAccessAreasService } from '../../services/accessAreas';
import { getSettingService } from '../../services/Settings';

const WidgetResourcesInPlaceState = ({ children }) => {

    const initialState = {
        resources: [],
        codesTofilter: {
            openingCodeSelectedInWidget: [],
            buildingCodeSelectedInWidget: [],
            resourcesTypesSelectedInWidget: ['EMP', 'VEH', 'VIS']
        },
        entitySelected: {
            openingSelectedInTheWidget: '',
            buildingSelectedInTheWidget: '',
        },
        levelSelected: 'openings',
        isFetching: true,
        error: {
            ok: false,
            text: ''
        }
    }

    const [state, dispatch] = useReducer(WidgetResourcesInPlaceReducer, initialState);

    const setResourcesInPlaceLoading = () => {
        dispatch({
            type: 'SET_RESOURCES_IN_PLACE_LOADING'
        });
    }

    const getResourcesInPlaceByOpennings = async (openingId = '', buildingId = '', resourcesTypes = []) => {
        try {
            setResourcesInPlaceLoading();

            const resources = await getAllResourcesInPlaceByOpennings(openingId, buildingId, resourcesTypes);

            const responseChanged = resources.data.response.map(obj => {
                // Creamos un nuevo objeto con las claves renombradas
                return {
                    entityCode: obj["opening_code"],
                    entityDescription: obj["opening_description"],
                    entityHasToSearch: obj["hasAreas"] ? obj["hasAreas"] : null,
                    employeesIn: obj["employeesIn"],
                    vehiclesIn: obj["vehiclesIn"],
                    visitorsIn: obj["visitorsIn"]
                };
            });

            if (resources.ok) {
                dispatch({
                    type: 'SET_RESOURCES_IN_PLACE',
                    payload: {
                        resources: responseChanged,
                        codesTofilter: state.codesTofilter,
                        entitySelected: {
                            openingSelectedInTheWidget: ''
                        },
                        levelSelected: 'openings',
                        error: {
                            ok: false,
                            text: ''
                        }
                    }
                })

            } else {
                let errorMsg;
                switch (resources.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }
                dispatch({
                    type: 'SET_RESOURCES_IN_PLACE',
                    payload: {
                        resources: state.resources,
                        codesTofilter: state.codesTofilter,
                        entitySelected: {
                            openingSelectedInTheWidget: ''
                        },
                        levelSelected: 'openings',
                        error: {
                            ok: true,
                            text: errorMsg
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'SET_RESOURCES_IN_PLACE',
                payload: {
                    resources: state.resources,
                    codesTofilter: state.codesTofilter,
                    entitySelected: {
                        openingSelectedInTheWidget: ''
                    },
                    levelSelected: 'openings',
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
        }
    }

    const getResourcesInPlaceByBuildings = async (openingId = '', buildingId = '', resourcesTypes = [], codes, entityType) => {

        try {
            setResourcesInPlaceLoading();

            const resources = await getAllResourcesInPlaceByBuilding(openingId, buildingId, resourcesTypes);

            if (resources.ok) {

                const responseChanged = resources.data.response.map(obj => {
                    return {
                        entityCode: obj["buildingId"],
                        entityDescription: obj["buildingDescription"],
                        entityHasToSearch: obj["hasAreas"],
                        entityToReturn: obj["openingCode"],
                        employeesIn: obj["employeesIn"],
                        vehiclesIn: obj["vehiclesIn"],
                        visitorsIn: obj["visitorsIn"]
                    };
                });

                dispatch({
                    type: 'SET_RESOURCES_IN_PLACE',
                    payload: {
                        resources: responseChanged,
                        codesTofilter: codes ? codes : state.codesTofilter,
                        entitySelected: {
                            openingSelectedInTheWidget: entityType,
                            buildingSelectedInTheWidget: '',
                        },
                        levelSelected: 'buildings',
                        error: {
                            ok: false,
                            text: ''
                        }
                    }
                })

            } else {
                let errorMsg;
                switch (resources.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        return 'PARAM_ERROR';
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'SET_RESOURCES_IN_PLACE',
                    payload: {
                        resources: state.resources,
                        codesTofilter: codes ? codes : state.codesTofilter,
                        entitySelected: {
                            openingSelectedInTheWidget: entityType
                        },
                        levelSelected: 'buildings',
                        error: {
                            ok: true,
                            text: errorMsg
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'SET_RESOURCES_IN_PLACE',
                payload: {
                    resources: state.resources,
                    codesTofilter: state.codesTofilter,
                    entitySelected: {
                        openingSelectedInTheWidget: entityType
                    },
                    levelSelected: 'buildings',
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
        }
    }

    const getResourcesInPlaceByAreas = async (buildingId = '', codes, entityType) => {

        try {
            setResourcesInPlaceLoading();

            const areasResponse = await getAccessAreasService({ buildings: [buildingId] });
            const accessAreas = areasResponse.data.response;

            const params = '?keyword=mandatory_area_select';
            const freeAccessResponse = await getSettingService(params);
            const freeAccess = freeAccessResponse.data.response;

            const resources = await getAllResourcesInPlaceByAreas(buildingId);

            if (resources.ok) {

                let responseChanged = resources.data.response.map(obj => {
                    return {
                        entityCode: obj["areaId"],
                        entityDescription: obj["areaDescription"] ? obj["areaDescription"] : t('FREE_ACCESS_AREA'),
                        entityToReturn: obj["areaCode"],
                        employeesIn: obj["employeesIn"],
                        vehiclesIn: obj["vehiclesIn"],
                        visitorsIn: obj["visitorsIn"]
                    };
                });

                const freeAccessArea = responseChanged.find(obj => obj.entityCode === null);

                const thereAreResourcesInFreeAccessArea = freeAccessArea.employeesIn > 0 || freeAccessArea.vehiclesIn > 0 || freeAccessArea.visitorsIn > 0;

                const thereAreAccessAreas = accessAreas.length > 0;

                //Se elimina el acceso libre cuando:
                //1. Hay areas
                //2. No hay empleados ingresados en acceso libre
                //3. No hay acceso libre (Es configurable)

                if (
                    thereAreAccessAreas &&
                    (!thereAreResourcesInFreeAccessArea || !freeAccess)
                ) {
                    responseChanged = responseChanged.filter(obj => obj.entityCode !== null);
                }

                dispatch({
                    type: 'SET_RESOURCES_IN_PLACE',
                    payload: {
                        resources: responseChanged,
                        codesTofilter: codes ? codes : state.codesTofilter,
                        entitySelected: {
                            openingSelectedInTheWidget: state.entitySelected.openingSelectedInTheWidget,
                            buildingSelectedInTheWidget: entityType
                        },
                        levelSelected: 'areas',
                        error: {
                            ok: false,
                            text: ''
                        }
                    }
                })

            } else {
                let errorMsg;
                switch (resources.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        return 'PARAM_ERROR';
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'SET_RESOURCES_IN_PLACE',
                    payload: {
                        resources: state.resources,
                        codesTofilter: codes ? codes : state.codesTofilter,
                        entitySelected: state.entitySelected,
                        levelSelected: 'buildings',
                        error: {
                            ok: true,
                            text: errorMsg
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'SET_RESOURCES_IN_PLACE',
                payload: {
                    resources: state.resources,
                    codesTofilter: state.codesTofilter,
                    entitySelected: state.entitySelected,
                    levelSelected: 'buildings',
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
        }
    }


    const setCodesInTheResourcesInPlace = (codes) => {
        dispatch({
            type: 'SET_CODES_IN_PLACE',
            payload: codes
        })
    }

    const setLevelInTheWidget = (level) => {
        dispatch({
            type: 'SET_LEVEL_IN_THE_WIDGET',
            payload: level
        })
    }

    return (
        <WidgetResourcesInPlaceContext.Provider
            value={{
                widgetResourcesInPlaceState: state,
                getResourcesInPlaceByOpennings,
                getResourcesInPlaceByBuildings,
                getResourcesInPlaceByAreas,
                setCodesInTheResourcesInPlace,
                setLevelInTheWidget
            }}
        >
            {children}
        </WidgetResourcesInPlaceContext.Provider>
    )
}

export default WidgetResourcesInPlaceState